import { createContext, useContext, useState } from 'react'

const createPostStat = ({ likeCount, repostCount, replyCount, currentUserLiked }) => ({
  likeCount: likeCount || 0,
  repostCount: repostCount || 0,
  replyCount: replyCount || 0,
  currentUserLiked: currentUserLiked || 0,
})

const PostStatsContext = createContext();
const PostStatsProvider = ({ children }) => {
  const [postStats, setPostStats] = useState({})

  const _insert = (postUuid, newPost, postStats) => {
    postStats[postUuid] = createPostStat(newPost)
    return postStats
  }

  const insertStat = (post) => {
    const newPostStats = { ...postStats }
    setPostStats(_insert(post?.uuid, post, newPostStats))
  }

  const insertStats = (posts=[]) => {
    if (!Array.isArray(posts)) return;
    const newPostStats = { ...postStats }
    // Loop through posts, parse stats, and insert to new posts object
    posts.forEach((post) => {
      _insert(post?.uuid, post, newPostStats)
    })
    // set new post stats
    setPostStats(newPostStats)
  }

  const getStat = (postUuid) => {
    return postStats[postUuid]
  }

  return (
    <PostStatsContext.Provider value={{
      insertStat,
      insertStats,
      getStat,
    }}>
      {children}
    </PostStatsContext.Provider>
  )
}

const usePostStatsContext = () => useContext(PostStatsContext)

export default usePostStatsContext

export { PostStatsContext, PostStatsProvider, usePostStatsContext }
